import { render, staticRenderFns } from "./VOpeningHour.vue?vue&type=template&id=0e7b5789"
import script from "./VOpeningHour.vue?vue&type=script&lang=ts"
export * from "./VOpeningHour.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports